import { BBox } from 'geojson';
import { LngLatBounds } from 'mapbox-gl';

export const bboxToLngLatBounds = (bbox?: BBox) => {
  return bbox
    ? new LngLatBounds([bbox[0], bbox[1], bbox[2], bbox[3]])
    : undefined;
};
